import { CURRENCY, WALLET_CODE } from './wallet.interfaces';
export enum BONUS_REWARD_TYPE {
  CASHBACK = 'CASHBACK',
  FIDELIDADE = 'FIDELIDADE',
}
export enum BONUS_EVENT {
  ONEDAY_BIG_DEPOSIT_LOOSED = 'ONEDAY_BIG_DEPOSIT_LOOSED',
  ONE_WEEK_WITHOUT_MOVEMENTS = 'ONE_WEEK_WITHOUT_MOVEMENTS',
  REGISTERED_3DAYS_NO_DEPOSIT = 'REGISTERED_3DAYS_NO_DEPOSIT',
  REGISTERED_9DAYS_NO_DEPOSIT = 'REGISTERED_9DAYS_NO_DEPOSIT',
}
export enum BONUS_TYPE {
  BEMVINDO = 'bemVindo',
  BEMVINDO_100 = 'bemVindo_100',
  BEMVINDO_50 = 'bemVindo_50',
  FIDELIDADE = 'fidelidade',
  CASHBACK = 'cashback',
  TESTDRIVE_5 = 'test-drive-5',
  TESTDRIVE_10 = 'test-drive-10',
  TESTDRIVE_20 = 'test-drive-20',
  RECHARGE = 'recharge',
}
export enum BONUS_EVENT_STATE {
  POOL = 'pool',
  ACTIVE = 'active',
  EXPIRED = 'expired',
  APPLIED = 'applied',
}
export interface IBonusEvent {
  _id?: string;
  user_id: string;
  type: BONUS_EVENT;
  bonus_type: BONUS_TYPE;
  state: BONUS_EVENT_STATE;
  createdAt: number;
  endAt: number;
  wallet: WALLET_CODE;
  promo_code_id?: string;
}
export interface IBonusReward {
  type: BONUS_REWARD_TYPE;
  amount_grated: number;
  amount_used: number;
  created_at: number;
  end_at: number;
  state: BONUS_STATE;
  currency: CURRENCY;
  deposit_id: string;
  user_id: string;
  movements: IBonusMovement[];
}
export interface IBonusMovement {
  _id?: string;
  user_id: string;
  amount: number;
  currency: CURRENCY;
  timestamp: number;
}
export enum BONUS_STATE {
  ACTIVE = 'active',
  CLOSED = 'closed',
}
export enum BONUS_STATUS {
  PENDING = 'pending',
  APPLIED = 'applied',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected',
  APPLIED_COMPLIANCE = 'applied_compliance',
}
export interface IBonusTransaction {
  status: BONUS_STATUS;
}
export interface IPromotion {
  _id?: string;
  denom: string;
  desc: string;
  start_at: number;
  end_at: number;
  bonuses: string[];
}
export interface IBonus {
  denom: string;
  desc: string;
  currency: CURRENCY;
  amount?: number;
  state: BONUS_STATE;
  image_url: string;
}
export interface IPromCode {
  _id?: string;
  user_id: string;
  status: BONUS_STATUS;
  currency: CURRENCY;
  bonus: BONUS_TYPE;
  timestamp: number;
  compliance_factor: number;
  settled_at?: number;
  amount?: number;
  code?: string;
  employee_id?: string;
  expires_at?: number;
  deposit_id?: string;
}
